import { SelectableCard } from 'components/Cards/SelectableCard';

type IGiveByCard = {
  caption: string;
  title: string;
  description: string;
  cta: string;
  cta_link: string;
  image: string;
};

interface IGiveBySelectorConfig {
  eyebrow: string;
  title: string;
  cards: IGiveByCard[];
}

export const GiveBySelectorSection = ({
  giveByConfig,
}: {
  giveByConfig: IGiveBySelectorConfig;
}) => {
  if (!giveByConfig?.cards?.length) {
    return null;
  }

  return (
    <div className="give-by-section">
      <span className="eyebrow-text">{giveByConfig.eyebrow}</span>
      <span className="h2-dtm color-white">{giveByConfig.title}</span>
      <div className="give-by-cards">
        {giveByConfig.cards.map(card => (
          <SelectableCard
            key={card.cta_link}
            image={card.image}
            caption={card.caption}
            title={card.title}
            description={card.description}
            cta={card.cta}
            ctaLink={card.cta_link}
          />
        ))}
      </div>
    </div>
  );
};
